/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */

(function($){
	'use strict';

	$(function(){

            function setCookie(cname, cvalue, exdays) {
                var d = new Date();
                d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
                var expires = "expires="+d.toUTCString();
                document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
            }
            
            function getCookie(cname) {
                var name = cname + "=";
                var ca = document.cookie.split(';');
                for(var i = 0; i < ca.length; i++) {
                    var c = ca[i];
                    while (c.charAt(0) == ' ') {
                        c = c.substring(1);
                    }
                    if (c.indexOf(name) == 0) {
                        return c.substring(name.length, c.length);
                    }
                }
                return "";
            }
        
            $(".template-product .RoundButton.RoundButton--small.RoundButton--flat").click(function(){
                $(".Product__ActionItem").toggleClass("minHeight");
            });

            //$('.care .care--container .care--tabs').tabs({ active: 1 });

            $('.accordion').accordion({
                heightStyle: "content",
                collapsible: true,
                active: false
            });

            $('.page_accordion').accordion({
                heightStyle: "content",
                collapsible: true,
                active: false
            });
            $(".Search__Input").keypress(function() {
                $("#Search").find(".Search__Results").addClass("container_padding");
            });
            $(".Search__Input").keydown(function() {
                //$("#Search").find(".Search__Results").removeClass("container_padding");
            });
            $(".Search__Close").click(function(){
                //$("#Search").find(".Search__Results").removeClass("container_padding");
                $(".search_image").show();
            });
            $(".search_image").click(function(){
                $("#Search").removeClass("search_close");
                $(this).hide();
                setTimeout(function(){
                    $("#Search").find('input[type="search"]').focus();
                }, 600);
            });
            $("#search_open").click(function(){
              console.log("click");
                $("#Search").removeClass("search_close");
                $("#Search").addClass("search_active");
              	$("#search_overlay").addClass("SearchOverlay is-visible");
              $(".boost-pfs-search-suggestion-wrapper").style("z-index: 99;");
            });
      $("#desktop_search_open").click(function(){
              console.log("click");
                $("#Search").removeClass("search_close");
                $("#Search").addClass("search_active");
              	$("#search_overlay").addClass("SearchOverlay is-visible");
                      $(".boost-pfs-search-suggestion-wrapper").style("z-index: 99;");

            });
      $(".Search__Close").click(function(){
              $("#search_overlay").removeClass("SearchOverlay is-visible");

      });
      $("#search_overlay").click(function(){
        $("#search_overlay").removeClass("SearchOverlay is-visible");
      	$("#Search").addClass("search_close");
              	$("#Search").removeClass("search_active");

      });
//             $("#Search").click(function(){
//                 $('html').removeClass('no-scroll');
//                 $(".search_image").show();
//                 if($(this).hasClass("search_active1") && $(this).hasClass("search_active")){
//                     $(this).removeClass("search_active1");
//                 }else{
//                     $(this).removeClass("search_modal_open");
//                     $(this).addClass("search_close");
//                     console.log("try");
//                 }
//             });
            $(".Search__SearchBar .Search__Input").click(function(){
                if($("#Search").hasClass("search_active")){
                    $("#Search").addClass("search_active1");
                    $("#Search").addClass("search_modal_open");
                    console.log("qweqe");
                }
            });
            $(".SizeSwatch").click(function(){
                setTimeout(function(){
                 $(".sku_container").find(".variant-sku").text($(".selected_SKU").children("option:selected").attr("data-sku"));
                },100)
            });
            var productPage = false;
            if ( $('body').is('.template-product') ) {
                productPage = true;
            }
            $(".swatch_container").click(function(){
                $(".swatch_container").removeClass("swatch_indicator");
                $(this).addClass("swatch_indicator");
            });
            
            $(".swatch-size .swatch-element").click(function(){
                $(".swatch-size .swatch-element").removeClass("swatch_indicator");
                $(this).addClass("swatch_indicator");
            });

            $('#SearchInput').keydown(function(e) {
                console.log('search!', $(this).closest('form'));
                if (e.keyCode == 13) {
                    $(this).closest('form').submit();
                }
            });

            var gdprPopup = getCookie('gdpr_popup');
            var gdprBar = $('.cookieBar');
            if ( gdprPopup != "1" ) {
                gdprBar.show();
            }
            
            $('.cookieBar_button').click(function(e) {
                e.preventDefault();
                setCookie('gdpr_popup', '1', 30);
                gdprBar.hide();
            });

            //Popup Newsletter
            $('.popup-overlay').click(function() {
                $('.NewsletterPopup').find('.NewsletterPopup__Close').trigger('click');
            });

            var currentColorTag = $('.CollectionMain').data('current-color');
            if ( currentColorTag ) {
                console.log(currentColorTag);
                let color_input = $('.ProductItem__ColorSwatchList input[value*='+ currentColorTag +']');
                color_input.each(function() {
                    let product = $(this).closest('.ProductItem');
                    let img = product.find('.ProductItem__Image').not('.ProductItem__Image--alternate');
                    let color_image = $(this).attr('data-image-url');
                    img.removeClass('Image--lazyLoaded').addClass('Image--lazyLoad').attr('data-src', color_image);
                });
            }

            document.addEventListener('variant:changed', function(event) {
                var BISTrigger = $('#BIS_trigger');
                var variant = event.detail.variant;
                var available = variant.available;
                if ( available ) {
                    BISTrigger.hide();
                } else {
                    BISTrigger.show().attr('data-variant-id', variant.id);
                }
              
              	if (variant) {
                  var form = $('.ProductForm');
                  for (var i=0,length=variant.options.length; i<length; i++) {
                    var radioButton = form.find('#SingleOptionSelector-'+ i ).val(variant.options[i]).trigger("change");
                  }
                }
            });
      
      		function updateWishCount() {
              if(!window.SwymCallbacks){window.SwymCallbacks = [];}
              window.SwymCallbacks.push(function(){
                _swat.fetchWrtEventTypeET(function(products){
                  $('.wishlist-link').addClass('wish-ready');
                  if ( products.length >= 1 ) {
                   console.log(products.length);
                   $('.wishlist-link').addClass('active');
                   $('.wish-count').text('('+ products.length + ')');
                }
              }, _swat.EventTypes.addToWishlist);});
      		}
      		updateWishCount();
      
      		$('.swym-button').click(function() {
              setTimeout(function() {
              	updateWishCount();
              }, 3000);
            });
	});
  
    document.addEventListener('product:added', function(event) {
      var variant = event.detail.variant; // Get the variant that was added
      var quantity = event.detail.quantity; // Get the quantity that was added
      
      var _learnq = window._learnq || [];
	  console.log(_learnq);
      _learnq.push(["track", "Added to Cart", {
        AddedItemPrice: variant.price / 100,
        AddedItemProductID: variant.id,
        AddedItemProductName: variant.name,
        AddedItemUrl: location.href,
        AddedItemImageUrl: 'https:'+afterpay_product.featured_image,
        AddedItemQuantity: quantity,
        AddedItemSKU: variant.sku
      }]);
    });
})(jQuery);